import { Tabs } from 'antd';
import React from 'react';
import HoursOfOperation from './components/HoursOfOperation';
import Holiday from './components/Holiday';
import { translate } from 'libs';

const { TabPane } = Tabs;

const AutomatedResponse = () => {
  return (
    <div className="automated-response">
      <Tabs defaultActiveKey="1" className="automated-response-tabs">
        <TabPane tab={translate('settingPage.automatedResponse.hoursOfOperation')} key="1">
          <HoursOfOperation />
        </TabPane>
        <TabPane tab={translate('settingPage.automatedResponse.holiday')} key="2">
          <Holiday />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default React.memo(AutomatedResponse);
